import { Button, ButtonProps } from '@mui/material'
import { produceWithPatches } from 'immer';
import { ReactNode } from 'react';
import ReqPerm from '../../../routes/RequreAuth/permission';
export interface ISaveButtonProps {
  children: ReactNode,
  loading?: boolean,
  disabled?: boolean,
  permission?: 'create' | 'update' //check permission CRUD and read of user
}

export default function SaveButton({ children, disabled, permission, loading, ...rest }: ISaveButtonProps & ButtonProps) {

  if (permission) {
    return (
      <ReqPerm require={permission}>
        <Button variant="contained" type='button' {...rest} disabled={loading || disabled} sx={{ minWidth: '92px', ...rest?.sx }}>{loading ? 'สักครู่' : children}</Button>
      </ReqPerm>
    )
  }
  return (
    <Button variant="contained" type='button' {...rest} disabled={loading || disabled} sx={{ minWidth: '92px', ...rest?.sx }}>{loading ? 'สักครู่' : children}</Button>
  );
}
